import { gql } from '@apollo/client'

export default gql(`
    mutation updateAccessRoleGroup($description: String $id: ID $name: String $modules: [ModulePermissionsInput] $oldUsers: [CreateUserInput] $newUsers: [CreateUserInput] $project: String $ip: [String] $masterFlag: Boolean) {
        updateAccessRoleGroup(
            input: {
                id: $id
                name: $name
                description: $description
                modules: $modules
                oldUsers: $oldUsers
                newUsers: $newUsers
                ip: $ip,
                masterFlag: $masterFlag
            }
            project: $project
        ){
            id
            name
            description
            createdAt
            ip
            masterFlag
            modules{
                name
                permissions
            }
            users{
                id
                accessRoleGroups {
                    id
                }
            }
        }
    }
`)
